import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TransferStateService } from '@scullyio/ng-lib';

@Injectable({
  providedIn: 'root',
})
export class ArticleResolver implements Resolve<any> {
    constructor(private http: HttpClient,
      private transferStateService:TransferStateService) {}
  
    resolve(route: ActivatedRouteSnapshot): Observable<any> {
      const lang = route.url[0].path;
          
      const url = `../../../assets/${environment.projectName}/content/${lang}/articles/articles.json`;
      const metadataUrl = `../../../assets/${environment.projectName}/content/${lang}/articles/meta-data.json`;
      
      return forkJoin({
        data: this.transferStateService.useScullyTransferState('maindata',this.http.get<any>(url).pipe(catchError(() => of(null)))),
        meta: this.transferStateService.useScullyTransferState('metadata',this.http.get<any>(metadataUrl).pipe(catchError(() => of(null))))
      }).pipe(
        map((result) => ({
          data: result.data,
          meta: result.meta
        })),
        catchError((error) => {
          console.error('Error fetching pricing or metadata:', error);
          return of(null);
        })
      );
    }
}
